import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import _ from "lodash";
import moment from "moment";
import PatientForm from "../Forms/PatientForm";
import AppointmentForm from "../TrackAppointment/AppointmentForm";
import ActivityTab from "./components/ActivityTab";
import GPReportListPanel from "./components/GPReportListPanel";
import ManageTasksForm from "../Forms/ManageTasksForm";
import ActingPatientForm from "../Forms/ActingPatientForm";
import {
  archiveService,
  unArchiveService,
  createAppointmentNotesService,
  createAppointmentService,
  deleteAppointmentService,
  informAppointmentDeletion,
  rebuildService,
  selectHospital,
  sendSMSService,
  updateIvr,
  updatePatientService,
  updateSMSSent,
  updateSnapformSent,
  updateTasksService,
  changeAppointmentService,
  updateFinNo,
} from "../../services/workflow";
import { formatDateTime } from "../../utils";
import {
  generateCreationTimestamp,
  getRemainingWeeksToAppointment,
  buildWorkflowSortOrders,
  appendGpReportSortIteratees,
  applyWorkflowSortingClick,
} from "./utils";
import { setDisplayArchiveOnly, setPageSize } from "./workflowSlice";
import { ADMIN_ROLE, CLIENT_APPOINTMENTS, workflowClientTab } from "../../constants";
import { shouldUnarchiveOnStatusChange } from "../../utils/splitClientAppointmentsByTab";
import {
  appointmentDateFieldFilter,
  bookingInfoFilter,
  caseManagerFieldFilter,
  coordinatorFilter,
  creationDateTimeFieldFilter,
  dateFieldFilter,
  generalBooleanFilter,
  generalFieldFilter,
  referrerFieldFilter,
  specialityFieldFilter,
  usernameFieldFilter,
  gpReportStatusFilter,
} from "./filters/fieldFilter";
import getReferrerFullName from "./services/getReferrerFullName";
import getCaseManagerById from "./services/getCaseManagerById";
import getSMSLogs from "./services/getSMSLogs";
import { CREATION_TIME_SECTION } from "./constants";
import EmailSection from "./components/EmailSection";
import SecureFileTab from "./components/SecureFileTab";
import { getToggleEnabled, TOGGLES } from "../../toggles";

import UserList from "./components/UserReport/UserList";
import TodoListTab from "./components/TodoListTab";
import ManualSms from "./components/ManualSms";
import { getClinicPreferenceService } from "../../services/clinic";
import { getVerifiedOutboundLetters } from "../../utils/gpReport";
import ArchiveAPTForm from "../Forms/ArchiveAPTForm";
import DeleteWorkflowForm from "../Forms/DeleteWorkflowForm";
import WorkflowHistoryList from "./components/WorkflowHistories";
import { isManualArchiveWorkflowEnabled, isSetWorkflowStatusEnabled } from "../../infra/featureToggle";
import WorkflowTableItem from "./components/WorkflowTableItem";
import NotificationLogList from "./components/NotificationLogList";
import { getUsers } from "../../services/auth";

import { displayDateTime } from "../../utils/dateDisplay";
const isDataFromPMS = process.env.REACT_APP_DATA_SOURCE === "pms-api";

const mapStateToProps = (state) => ({
  archivedClientAppointments: state.workflow.archivedClientAppointments,
  pageSize: state.workflow.pageSize,
  clientGroups: state.app.clientGroups,
  practitioners: state.app.practitioners,
  referrers: state.app.referrers,
  displayArchiveOnly: state.workflow.displayArchiveOnly,
});

const mapDispatchToProps = { setPageSize, setDisplayArchiveOnly };

const ArchivedWorkFlow = ({
  clientGroups = [],
  practitioners = [],
  referrers = [],
  archivedClientAppointments = [],
  pageSize,
  setPageSize,
  setDisplayArchiveOnly,
}) => {
  const isSecureFilesEnabled = getToggleEnabled(TOGGLES.SECURE_FILES);
  useEffect(() => {
    setDisplayArchiveOnly(true);
  }, [setDisplayArchiveOnly]);
  const practitionerProfiles = useSelector((state) => state.app.specialistProfiles);
  const [activeCa, setActiveCa] = useState(null);
  const [activeCaId, setActiveCaId] = useState("");
  const [isLoadingCa, setIsLoadingCa] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [caData, setCaData] = useState([]);
  const [inAction, setInAction] = useState(false);
  const [actionSuccess, setActionSuccess] = useState(null);
  const [actionErrorMessage, setActionErrorMessage] = useState(null);
  const [modalFormName, setModalFormName] = useState("");

  const [isActingPatient, setIsActingPatient] = useState(false);

  const [clientFilter, setClientFilter] = useState("");
  const [URNFilter, setURNFilter] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");
  const [dobFilter, setDobFilter] = useState("");
  const [creationDateTimeFilter, setCreationDateTimeFilter] = useState("");
  const [appointmentDateFilter, setAppointmentDateFilter] = useState("");
  const [referrerFilter, setReferrerFilter] = useState("");
  const [caseManagerFilter, setCaseManagerFilter] = useState("");
  const [hospitalFilter, setHospitalFilter] = useState("");
  const [gpReportFilter, setGpReportFilter] = useState("");
  const [nurseCheckFilter, setNurseCheckFilter] = useState("");
  const [finFilter, setFinFilter] = useState("");
  const [appointmentFilter, setAppointmentFilter] = useState("");
  const [preConsultFilter, setPreConsultFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [specialityFilter, setSpecialityFilter] = useState("");
  const [displayDropdownList, setDisplayDropdownList] = useState(false);
  const [timeType, setTimeType] = useState(CREATION_TIME_SECTION.CREATION_TIME);

  //const [pageSize, setPageSize] = useState(10);
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [totalNumOfRows, setTotalNumOfRows] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [pageFrom, setPageFrom] = useState(1);
  const [pageTo, setPageTo] = useState(10);

  const [workflowSelectedTabId, setWorkflowSelectedTabId] = useState("logs");
  const [clinicPreference, setClinicPreference] = useState({});

  const [sortColumns, setSortColumns] = useState([
    {
      column: "creationTimestamp",
      order: false,
      isCurrentClickedColumn: true,
    },
  ]);

  const [searchCaId, setSearchCaId] = useState(null);

  const location = useLocation();
  const history = useHistory();

  const clearUrlIdParameter = () => {
    if (searchCaId) {
      const params = new URLSearchParams(location.search);
      params.delete("id");
      const newSearch = params.toString();
      history.replace({
        pathname: location.pathname,
        search: newSearch ? `?${newSearch}` : "",
      });
      setSearchCaId(null);
      setActiveCaId("");
      setActiveCa(null);
    }
  };
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const caId = params.get("id");
    setSearchCaId(caId);
  }, [location]);

  useEffect(() => {
    setSortColumns([
      {
        column: "creationTimestamp",
        order: false,
        isCurrentClickedColumn: true,
      },
    ]);
  }, []);

  useEffect(() => {
    const getClinicPreference = async () => {
      const result = await getClinicPreferenceService();
      setClinicPreference(result);
    };
    getClinicPreference();
  }, []);

  const handleCloseModal = () => {
    setOpenModal(false);
    setModalFormName("");
    setActionSuccess(null);
    setInAction(false);
  };

  const handleUpdateClient = (ca) => async ({ client, hospital }) => {
    setInAction(true);
    setActionErrorMessage(null);
    const id = _.get(ca, "id", "");
    const clientId = _.get(ca, "client.clientId", "");
    try {
      await updatePatientService({ id, clientId, client });
      await selectHospital(id, hospital);
      setActionSuccess(true);
    } catch (error) {
      console.error("error when update client", error);
      setActionSuccess(false);
    } finally {
      setInAction(false);
    }
  };

  const handleAddAppointment = () => async (appointment) => {
    setInAction(true);
    setActionErrorMessage(null);
    try {
      await createAppointmentService({
        id: activeCa.id,
        appointment,
      });
      await createAppointmentNotesService({
        notes: appointment.notes,
        id: activeCa.id,
      });
      setActionSuccess(true);
    } catch (error) {
      setActionSuccess(false);
      return error;
    } finally {
      setInAction(false);
    }
  };

  const handleInformDeletion = async (data) => {
    setInAction(true);
    setActionErrorMessage(null);
    try {
      await informAppointmentDeletion(data);
      setActionSuccess(true);
    } catch (error) {
      setActionSuccess(false);
    } finally {
      setInAction(false);
    }
  };

  const handleDeleteAppointment = (id) => async (appointmentId, appointmentCanceledReason) => {
    setInAction(true);
    setActionErrorMessage(null);
    try {
      const requestBody = { id, appointmentId };
      if (appointmentCanceledReason && isDataFromPMS) {
        // PMS API expects appointmentCanceledReason in request body
        requestBody.appointmentCanceledReason = appointmentCanceledReason;
      }
      await deleteAppointmentService(requestBody);
      setActionSuccess(true);
    } catch (error) {
      setActionSuccess(false);
    } finally {
      setInAction(false);
    }
  };

  const handleChangeAppointment = (id) => async (
    appointmentId,
    startDateTime,
    endDateTime,
    duration,
    skipInitialSMS,
    bookingOptions
  ) => {
    setInAction(true);
    setActionErrorMessage(null);
    try {
      await changeAppointmentService({
        id,
        appointmentId,
        startDateTime,
        endDateTime,
        duration,
        skipInitialSMS,
        slotId: bookingOptions?.slotId,
        consultationType: bookingOptions?.consultationType,
      });
      setActionSuccess(true);
    } catch (error) {
      setActionSuccess(false);
    } finally {
      setInAction(false);
    }
  };

  const handleClickEditClient = async () => {
    setOpenModal(true);
    setModalFormName("edit_patient");
  };

  const handleClickAddCancelAppointment = async () => {
    setOpenModal(true);
    setModalFormName("add_cancel_appointment");
  };

  const handleClickChangeAppointment = async () => {
    setOpenModal(true);
    setModalFormName("change_appointment");
  };

  const handleSendSMSMessage = async (message) => {
    setInAction(true);
    setActionErrorMessage(null);
    const { phoneNumberMobile, firstName, lastName } = activeCa.client;
    try {
      await sendSMSService({
        id: activeCa.id,
        phoneNumber: phoneNumberMobile,
        patientFullName: `${firstName} ${lastName}`,
        template: message,
      });

      setActionSuccess(true);
    } catch (error) {
      setActionSuccess(false);
    } finally {
      setInAction(false);
    }
  };

  const handleClickManageTasks = () => {
    setOpenModal(true);
    setModalFormName("manage_tasks");
  };

  const handleClickActingPatient = async () => {
    setOpenModal(true);
    setModalFormName("acting_patient");
  };

  const handleActingPatient = async (answer) => {
    const result = answer === true ? "YES FROM TELECARE" : "NO FROM TELECARE";
    setIsActingPatient(true);
    await updateSMSSent(activeCaId, result);
    const ivr = _.get(
      _.find(archivedClientAppointments, (ca) => ca.id === activeCaId),
      "ivr",
      null
    );
    if (ivr) {
      await updateIvr(activeCaId, answer, ivr);
    }
    setIsActingPatient(false);
    setOpenModal(false);
  };

  const handleSnapform = async (answer) => {
    setIsActingPatient(true);
    await updateSnapformSent(activeCaId, answer);
    setIsActingPatient(false);
    setOpenModal(false);
  };

  const handleManageTasks = (id) => async (tasks, previousTasks, fin) => {
    setInAction(true);
    setActionErrorMessage(null);
    try {
      await updateTasksService({ id, tasks });
      await updateFinNo(activeCaId, fin);
      const shouldUnArchive = shouldUnarchiveOnStatusChange({
        previousStatus: _.get(previousTasks, "appointment_t.status"),
        nextStatus: _.get(tasks, "appointment_t.status"),
        preserveManualArchive: isManualArchiveWorkflowEnabled,
      });
      if (shouldUnArchive) {
        await handleUnArchiveAPT();
        handleCloseModal();
        clearUrlIdParameter();
      }
      setActionSuccess(true);
    } catch (error) {
      setActionSuccess(false);
    } finally {
      setInAction(false);
    }
  };

  const getTasks = () => {
    const clientApt = archivedClientAppointments.find((ca) => ca.id === activeCa?.id);

    if (!clientApt) return null;
    const { appointment_t, letter_t, pre_consult_t, gp_report_t, gp_report } = clientApt;
    const result = {
      appointment_t: {
        coordinator: _.get(appointment_t, "coordinator", ""),
        status: _.get(appointment_t, "status", ""),
        notes: _.get(appointment_t, "notes", ""),
        urgent: _.get(appointment_t, "urgent", false),
        biologics: _.get(appointment_t, "biologics", false),
        interpreter: _.get(appointment_t, "interpreter", false),
        name_referral: _.get(appointment_t, "name_referral", false),
        weeks_to_appointment: _.get(appointment_t, "weeks_to_appointment", ""),
        expected_appointment_date: _.get(appointment_t, "expected_appointment_date", null),
        is_new_appointment: _.get(appointment_t, "is_new_appointment", false),
        cont_or_tbc: _.get(appointment_t, "cont_or_tbc", ""),
        triage: _.get(appointment_t, "triage", false),
        payment_consent: _.get(appointment_t, "payment_consent", false),
      },
      letter_t: {
        coordinator: _.get(letter_t, "coordinator", ""),
        status: _.get(letter_t, "status", ""),
        notes: _.get(letter_t, "notes", ""),
        urgent: _.get(letter_t, "urgent", false),
      },
      pre_consult_t: {
        coordinator: _.get(pre_consult_t, "coordinator", ""),
        status: _.get(pre_consult_t, "status", ""),
        notes: _.get(pre_consult_t, "notes", ""),
        urgent: _.get(pre_consult_t, "urgent", false),
        inspections: _.get(pre_consult_t, "inspections", []),
      },
      gp_report_t: {
        status: _.get(gp_report_t, "status", gp_report == null ? "" : "NC"),
      },
    };
    return result;
  };

  const handleClickRow = async (id, tabId = "logs") => {
    setIsLoadingCa(true);
    setActiveCaId(id);
    setActiveCa(_.find(archivedClientAppointments, (ca) => ca.id === id));
    setIsLoadingCa(false);
    setWorkflowSelectedTabId(tabId);
  };

  const handleClickUnarchive = () => {
    setOpenModal(true);
    setModalFormName("unarchive_apt");
  };

  const handleClickDelete = async () => {
    setOpenModal(true);
    setModalFormName("delete_apt");
  };

  const handleArchiveAPT = async () => {
    await archiveService({ selectedCaIds: [activeCaId] });
    setOpenModal(false);
  };

  const handleUnArchiveAPT = async () => {
    await unArchiveService({ selectedCaIds: [activeCaId] });
    setOpenModal(false);
    setActiveCaId("");
    setActiveCa(null);
    clearUrlIdParameter();
  };

  const handleCancelArchiveAPT = async () => {
    setOpenModal(false);
  };

  const renderOrderArrow = (column) => {
    const sortColumn = _.find(sortColumns, { column });
    if (!sortColumn) {
      return null;
    }

    if (sortColumn.order) {
      return (
        <span className="icon is-small" key={`${sortColumn.column}-${sortColumn.order}`}>
          <i className="fa-arrow-up fas"></i>
        </span>
      );
    }

    if (!sortColumn.order) {
      return (
        <span className="icon is-small" key={`${sortColumn.column}-${sortColumn.order}`}>
          <i className="fas fa-arrow-down"></i>
        </span>
      );
    }
  };

  const handleSortingClick = (ob) => {
    setSortColumns((prevSortColumns) => applyWorkflowSortingClick(prevSortColumns, ob));
  };

  const handleClickRebuild = async (id) => {
    setIsLoadingCa(true);
    setActionErrorMessage(null);
    try {
      await rebuildService(id);
      setActionSuccess(true);
    } catch (error) {
      setActionSuccess(false);
      setActionErrorMessage(error.response?.data?.error || null);
    } finally {
      setIsLoadingCa(false);
    }
  };

  const handleClearAllSorts = () => {
    setSortColumns([]);
  };

  const [coordinators, setCoordinators] = useState([]);

  useEffect(() => {
    async function fetchUsers() {
      const users = await getUsers(ADMIN_ROLE);
      setCoordinators(
        (users?.filter((user) => !user.isITStaff && !user.disabled) || []).map((user) => ({
          label: `${user.firstName} ${user.lastName}`,
          value: user.shortName,
        }))
      );
    }
    fetchUsers();
  }, []);

  useEffect(() => {
    let filters = [];
    !_.isEmpty(clientFilter) && filters.push(usernameFieldFilter(clientFilter));
    !_.isEmpty(specialityFilter) &&
      filters.push(specialityFieldFilter(specialityFilter, practitioners, practitionerProfiles));
    !_.isEmpty(dobFilter) && filters.push(dateFieldFilter(dobFilter, "client.dateOfBirth"));
    !_.isEmpty(creationDateTimeFilter) && filters.push(creationDateTimeFieldFilter(creationDateTimeFilter, timeType));
    !_.isEmpty(referrerFilter) && filters.push(referrerFieldFilter(referrerFilter, referrers));
    !_.isEmpty(caseManagerFilter) && filters.push(caseManagerFieldFilter(caseManagerFilter, practitioners));
    !_.isEmpty(hospitalFilter) && filters.push(generalFieldFilter(hospitalFilter, "location.name"));
    !_.isEmpty(URNFilter) && filters.push(generalFieldFilter(URNFilter, "client.ExternalId"));
    !_.isEmpty(categoryFilter) && filters.push(generalFieldFilter(categoryFilter, "category"));
    !_.isEmpty(appointmentDateFilter) && filters.push(appointmentDateFieldFilter(appointmentDateFilter));
    !_.isEmpty(appointmentFilter) && filters.push(bookingInfoFilter(appointmentFilter, coordinators));
    !_.isEmpty(preConsultFilter) &&
      filters.push(coordinatorFilter(preConsultFilter, "pre_consult_t.coordinator", coordinators));
    !_.isEmpty(gpReportFilter) && filters.push(gpReportStatusFilter(gpReportFilter));
    !_.isEmpty(nurseCheckFilter) && filters.push(generalBooleanFilter(nurseCheckFilter, "gp_report_t.is_nurse_check"));
    !_.isEmpty(finFilter) && filters.push(generalFieldFilter(finFilter, "finNo"));
    let newCaData;

    if (searchCaId) {
      newCaData = archivedClientAppointments.filter((ca) => ca.id === searchCaId);
      setActiveCaId(searchCaId);
      setActiveCa(archivedClientAppointments.find((ca) => ca.id === searchCaId));
    } else {
      newCaData = filters.reduce((caData, filter) => filter(caData), archivedClientAppointments);
    }

    const generateSortOrder = () => buildWorkflowSortOrders(sortColumns);

    const generateSortColumnsIteratees = () => {
      const mappings = {
        creationTimestamp: (ca) => generateCreationTimestamp(ca, timeType),
        client: (ca) => `${_.get(ca, "client.firstName", "")} ${_.get(ca, "client.lastName", "")}`,
        dob: (ca) => ca.client.dateOfBirth,
        referrer: (ca) => getReferrerFullName(ca, referrers),
        practitioner: (ca) => getCaseManagerById(ca, practitioners),
        speciality: (ca) =>
          `${
            (practitionerProfiles.find(
              ({ id: practitionerId }) => _.get(ca, "practitioner.practitionerId", null) === practitionerId
            )?.specialities || [])[0]?.name || ""
          }`,
        location: (ca) => _.get(ca, "location.name", ""),
        appointment: (ca) => formatDateTime(_.get(ca, "appointment.startDateTime", ""), true, true),
        appointment_t: (ca) => getRemainingWeeksToAppointment(ca),
        letter_t: (ca) => [_.get(ca, "letter_t.status", ""), _.get(ca, "letter_t.coordinator", "")],
        status: (ca) => _.get(ca, "status", ""),
        pre_consult_t: (ca) => [_.get(ca, "pre_consult_t.status", ""), _.get(ca, "pre_consult_t.coordinator", "")],
        category: (ca) => _.get(ca, "category", ""),
      };

      return sortColumns.reduce((columnSorts, { column }) => {
        if (column === "gp_report") {
          return appendGpReportSortIteratees(columnSorts);
        }

        const columnSort = mappings[column];
        if (columnSort) {
          return [...columnSorts, columnSort];
        }

        return [...columnSorts];
      }, []);
    };

    newCaData = _.orderBy(newCaData, generateSortColumnsIteratees(), generateSortOrder());

    setTotalNumOfRows(newCaData.length);
    setTotalPages(Math.ceil(newCaData.length / pageSize));
    setPageFrom(currentPageIndex * pageSize + 1);

    const offset = newCaData.length % pageSize;
    const offsetPageSize = offset === 0 ? pageSize : offset;
    setPageTo(
      currentPageIndex === Math.ceil(newCaData.length / pageSize) - 1
        ? currentPageIndex * pageSize + offsetPageSize
        : currentPageIndex * pageSize + pageSize
    );

    setCaData(newCaData.slice(currentPageIndex * pageSize, currentPageIndex * pageSize + pageSize));
    // eslint-disable-next-line
  }, [
    archivedClientAppointments,
    clientFilter,
    URNFilter,
    categoryFilter,
    dobFilter,
    creationDateTimeFilter,
    appointmentDateFilter,
    appointmentFilter,
    preConsultFilter,
    specialityFilter,
    statusFilter,
    referrerFilter,
    caseManagerFilter,
    hospitalFilter,
    gpReportFilter,
    finFilter,
    currentPageIndex,
    pageSize,
    practitioners,
    referrers,
    timeType,
    sortColumns,
    searchCaId,
  ]);

  return (
    <div className="workflow">
      <div className={`${openModal ? "is-active " : ""}modal`}>
        <div className="modal-background form" onClick={handleCloseModal}></div>
        <div className="modal-content">
          <div className="box is-radiusless is-size-7">
            {modalFormName === "edit_patient" && (
              <PatientForm
                patient={_.get(activeCa, "client", null)}
                submit={handleUpdateClient(activeCa)}
                clientGroups={clientGroups}
                practitioners={practitioners}
                isLoading={inAction}
                actionName="Update"
                originalLocation={_.find(archivedClientAppointments, (ca) => ca.id === activeCaId)?.location}
                originalReferral={_.find(archivedClientAppointments, (ca) => ca.id === activeCaId)?.referral}
                originalCategory={_.find(archivedClientAppointments, (ca) => ca.id === activeCaId)?.category ?? ""}
                originalClinic={_.get(activeCa, "clinic", {})}
                originalReferrer={{
                  ..._.get(activeCa, "referrer", {}),
                  providerNumber: _.get(activeCa, "referral.referrerLocation.providerNumber", ""),
                }}
              />
            )}
            {(modalFormName === "add_cancel_appointment" || modalFormName === "change_appointment") && (
              <AppointmentForm
                clientAppointmentId={_.get(activeCa, "id", "")}
                location={_.get(
                  archivedClientAppointments.find((ca) => ca.id === activeCaId),
                  "location",
                  null
                )}
                URN={_.get(
                  archivedClientAppointments.find((ca) => ca.id === activeCaId),
                  "client.ExternalId",
                  ""
                )}
                isNewAppointment={_.get(activeCa, "appointment_t.is_new_appointment", false)}
                appointment={_.get(
                  _.find(archivedClientAppointments, (ca) => ca.id === activeCaId),
                  "appointment",
                  null
                )}
                preConsult={_.get(
                  _.find(archivedClientAppointments, (ca) => ca.id === activeCaId),
                  "pre_consult_t",
                  null
                )}
                isRTNoteFilled={_.get(
                  _.find(archivedClientAppointments, (ca) => ca.id === activeCaId),
                  "pre_consult_t.notes",
                  false
                )}
                selectedPractitioner={_.get(
                  _.find(archivedClientAppointments, (ca) => ca.id === activeCaId),
                  "practitioner",
                  null
                )}
                referralEmail={_.get(
                  _.find(archivedClientAppointments, (ca) => ca.id === activeCaId),
                  "referral.referrerLocation.email",
                  null
                )}
                referralExpiredDate={
                  _.has(
                    _.find(archivedClientAppointments, (ca) => ca.id === activeCaId),
                    "referral.endDate"
                  )
                    ? moment(
                        _.get(
                          _.find(archivedClientAppointments, (ca) => ca.id === activeCaId),
                          "referral.endDate"
                        )
                      )
                    : null
                }
                submit={handleAddAppointment()}
                inform={handleInformDeletion}
                specialty={_.get(activeCa, "speciality", "")}
                caseManager={_.get(activeCa, "practitioner", null)}
                remove={handleDeleteAppointment(_.get(activeCa, "id", ""))}
                change={handleChangeAppointment(_.get(activeCa, "id", ""))}
                client={_.get(activeCa, "client", {})}
                clinic={_.get(activeCa, "clinic", null)}
                practitioners={practitioners}
                isLoading={inAction}
                actionName={modalFormName}
              />
            )}
            {modalFormName === "manage_tasks" && (
              <ManageTasksForm
                submit={handleManageTasks(_.get(activeCa, "id", ""))}
                isLoading={inAction}
                caTasks={getTasks()}
                finNo={_.get(activeCa, "finNo", "")}
                createdDate={_.get(activeCa, "creationTimestamp", "")}
                isGpReportSelected={_.has(activeCa, "gp_report")}
                outboundLetterCount={getVerifiedOutboundLetters(activeCa).length}
              />
            )}
            {modalFormName === "acting_patient" && (
              <ActingPatientForm
                handleSubmit={handleActingPatient}
                handleSubmitSnap={handleSnapform}
                isSubmitting={isActingPatient}
              />
            )}
            {modalFormName === "archive_apt" && (
              <ArchiveAPTForm
                activeCa={activeCa}
                handleArchiveAPT={handleArchiveAPT}
                handleCancelArchiveAPT={handleCancelArchiveAPT}
              />
            )}
            {modalFormName === "unarchive_apt" && (
              <ArchiveAPTForm
                activeCa={activeCa}
                mode="unarchive"
                handleArchiveAPT={handleUnArchiveAPT}
                handleCancelArchiveAPT={handleCancelArchiveAPT}
              />
            )}
            {modalFormName === "delete_apt" && (
              <DeleteWorkflowForm
                id={activeCaId}
                appointment={_.get(
                  _.find(archivedClientAppointments, (ca) => ca.id === activeCaId),
                  "appointment",
                  null
                )}
                closeModal={() => setOpenModal(false)}
              />
            )}
            {_.isEmpty(modalFormName) && (
              <div>
                <span className="icon">
                  <i className="fas fa-cog fa-spin fa-lg" />
                </span>
                <span style={{ verticalAlign: "text-bottom" }}> loading ...</span>
              </div>
            )}
          </div>
        </div>
        <button className="modal-close is-large has-background-primary" aria-label="close" onClick={handleCloseModal} />
      </div>
      <UserList />
      <div className="ca-table">
        <div className="level-left">
          <button
            className="button is-primary clear-button is-radiusless is-size-7"
            aria-label="close"
            onClick={handleClearAllSorts}
          >
            Clear All Sortings
          </button>
        </div>
        <table className="table is-fullwidth is-narrow is-size-7">
          <thead>
            <tr>
              <th>
                <span>URN</span>
              </th>
              <th onClick={(e) => handleSortingClick("category")}>
                <span>Category</span>
                {renderOrderArrow("category")}
              </th>
              <th onClick={(e) => handleSortingClick("client")}>
                <span>Client</span>
                {renderOrderArrow("client")}
              </th>
              <th onClick={(e) => handleSortingClick("dob")}>
                <span>DOB</span>
                {renderOrderArrow("dob")}
              </th>
              <th className="time-container">
                <div className="label-container" onClick={(e) => handleSortingClick("creationTimestamp")}>
                  <span>{timeType}</span>
                  {renderOrderArrow("creationTimestamp")}
                </div>
                <div
                  className="dropdown dropdown-container"
                  onClick={(e) => setDisplayDropdownList(!displayDropdownList)}
                >
                  <div className="dropdown-trigger">
                    <button className="button" aria-haspopup="true" aria-controls="dropdown-menu">
                      <span className="icon is-small">
                        <i className="fas fa-angle-down" aria-hidden="true"></i>
                      </span>
                    </button>
                  </div>
                  <div
                    className={`dropdown-menu ${displayDropdownList ? "dropdown-menu-is-active" : ""}`}
                    id="dropdown-menu"
                    role="menu"
                  >
                    <div className="dropdown-content">
                      <div onClick={() => setTimeType(CREATION_TIME_SECTION.FIRST_SMS_TIME)} className="dropdown-item">
                        {CREATION_TIME_SECTION.FIRST_SMS_TIME}
                      </div>
                      <div onClick={() => setTimeType(CREATION_TIME_SECTION.CREATION_TIME)} className="dropdown-item">
                        {CREATION_TIME_SECTION.CREATION_TIME}
                      </div>
                    </div>
                  </div>
                </div>
              </th>
              <th onClick={(e) => handleSortingClick("referrer")}>
                <span>Referrer</span>
                {renderOrderArrow("referrer")}
              </th>
              <th onClick={(e) => handleSortingClick("practitioner")}>
                <span>Case Manager</span>
                {renderOrderArrow("practitioner")}
              </th>
              <th onClick={(e) => handleSortingClick("speciality")}>
                <span>Speciality</span>
                {renderOrderArrow("speciality")}
              </th>
              <th onClick={(e) => handleSortingClick("location")}>
                <span>Site</span>
                {renderOrderArrow("location")}
              </th>
              <th onClick={(e) => handleSortingClick("appointment")}>
                <span>APT Date</span>
                {renderOrderArrow("appointment")}
              </th>
              <th onClick={(e) => handleSortingClick("appointment_t")}>
                <span>Bookings</span>
                {renderOrderArrow("appointment_t")}
              </th>
              <th onClick={(e) => handleSortingClick("pre_consult_t")}>
                <span>Results</span>
                {renderOrderArrow("pre_consult_t")}
              </th>
              <th onClick={(e) => handleSortingClick("fin")}>
                <span>Admin Check Notes</span>
                {renderOrderArrow("fin")}
              </th>
              <th>
                <span>Admin Check</span>
              </th>
              <th onClick={(e) => handleSortingClick("gp_report")}>
                <span>GP report</span>
                {renderOrderArrow("gp_report")}
              </th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <td colSpan={15}>
                <div className="level">
                  <div className="level-right"></div>
                  <div className="level-right">
                    <div className="level-item">Rows per page:</div>
                    <div className="level-item">
                      <div className="field">
                        <div className="control">
                          <div className="select is-small">
                            <select
                              className="is-radiusless"
                              onChange={(e) => {
                                setCurrentPageIndex(0);
                                setPageSize(Number(e.target.value));
                              }}
                              value={pageSize}
                            >
                              <option value="10">10</option>
                              <option value="20">20</option>
                              <option value="30">30</option>
                              <option value="40">40</option>
                              <option value="50">50</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="level-item mx-4">
                      <span>{pageFrom}</span>
                      <span className="mx-1">-</span>
                      <span>{pageTo}</span>
                      <span className="mx-1">of</span>
                      <span>{totalNumOfRows}</span>
                    </div>
                    <div className="level-item mx-4">
                      <div className="go-start" onClick={() => setCurrentPageIndex(0)}>
                        <span className="icon is-medium has-text-primary">
                          <i className="fas fa-step-backward fa-lg"></i>
                        </span>
                      </div>
                      <div
                        className="go-previous"
                        onClick={() => {
                          setCurrentPageIndex((i) => (i === 0 ? i : i - 1));
                        }}
                      >
                        <span className="icon is-medium has-text-primary">
                          <i className="fas fa-chevron-left fa-lg"></i>
                        </span>
                      </div>
                      <div
                        className="go-next"
                        onClick={() =>
                          setCurrentPageIndex((i) => {
                            return i === totalPages - 1 ? i : i + 1;
                          })
                        }
                      >
                        <span className="icon is-medium has-text-primary">
                          <i className="fas fa-chevron-right fa-lg"></i>
                        </span>
                      </div>
                      <div className="go-end" onClick={() => setCurrentPageIndex(totalPages - 1)}>
                        <span className="icon is-medium has-text-primary">
                          <i className="fas fa-step-forward fa-lg"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tfoot>
          <tbody>
            <tr>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={URNFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setURNFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={categoryFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setCategoryFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={clientFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setClientFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={dobFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setDobFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={creationDateTimeFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setCreationDateTimeFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={referrerFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setReferrerFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={caseManagerFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setCaseManagerFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={specialityFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setSpecialityFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={hospitalFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setHospitalFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={appointmentDateFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setAppointmentDateFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={appointmentFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setAppointmentFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={preConsultFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setPreConsultFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={finFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setFinFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={nurseCheckFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setNurseCheckFilter(e.target.value);
                  }}
                />
              </td>
              <td>
                <input
                  className="input is-radiusless is-small"
                  type="text"
                  value={gpReportFilter}
                  onChange={(e) => {
                    setCurrentPageIndex(0);
                    setGpReportFilter(e.target.value);
                  }}
                />
              </td>
              {isSetWorkflowStatusEnabled && (
                <td>
                  <input
                    className="input is-radiusless is-small"
                    type="text"
                    value={statusFilter}
                    onChange={(e) => {
                      setCurrentPageIndex(0);
                      setStatusFilter(e.target.value);
                    }}
                  />
                </td>
              )}
            </tr>
            {caData.map((ca, index) => {
              return (
                <Fragment key={ca.id}>
                  <WorkflowTableItem
                    ca={ca}
                    clinicPreference={clinicPreference}
                    handleClickManageTasks={handleClickManageTasks}
                    caDataLength={caData.length}
                    activeCaId={activeCaId}
                    handleClickRow={handleClickRow}
                    timeType={timeType}
                    index={index}
                    clientAppointments={archivedClientAppointments}
                  />
                  {ca.id === activeCaId && (
                    <>
                      <tr className="is-active">
                        <td colSpan={15}>
                          <div className="tabs is-small is-boxed mt-1">
                            <ul>
                              {_.map(
                                workflowClientTab.filter(
                                  (t) => t.enabled === true && (t.id !== "secure_files" || isSecureFilesEnabled)
                                ),
                                (tab) => (
                                  <li
                                    key={tab.id}
                                    className={`${workflowSelectedTabId === tab.id ? "is-active " : ""}is-size-7`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setWorkflowSelectedTabId(tab.id);
                                    }}
                                  >
                                    {
                                      // eslint-disable-next-line
                                      <a href="/xxx" className="is-radiusless">
                                        <span>{tab.label}</span>
                                      </a>
                                    }
                                  </li>
                                )
                              )}
                            </ul>
                          </div>
                        </td>
                      </tr>
                      <tr className="is-active">
                        <td colSpan={15}>
                          <div className="tab-content py-2">
                            {workflowSelectedTabId === "logs" && (
                              <div className="columns is-1">
                                <div className="column is-narrow">
                                  <p className="menu-label">Appointment notification SMS</p>
                                  <div className="sms-logs has-background-white">
                                    {getSMSLogs(activeCa.id, archivedClientAppointments, "sms").map((sms, idx) => (
                                      <div className="columns is-1" key={idx}>
                                        <div
                                          className={`column is-narrow is-one-quarter is-family-monospace p-0 has-text-grey ${
                                            sms.patient ? "has-text-weight-semibold" : "has-text-weight-normal"
                                          }`}
                                        >
                                          {displayDateTime(sms.ts)}
                                        </div>
                                        <span
                                          className={`sms-log column py-0 pr-0 pb-2 ${
                                            sms.patient ? "has-text-weight-semibold" : "has-text-weight-normal"
                                          }`}
                                        >
                                          {sms.text}
                                        </span>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                                <div className="column is-narrow">
                                  <p className="menu-label">Manual SMS</p>
                                  <div className="sms-logs has-background-white">
                                    {getSMSLogs(activeCa.id, archivedClientAppointments, "manual_sms").map(
                                      (sms, idx) => (
                                        <div className="columns is-1">
                                          <div
                                            key={idx}
                                            className={`column is-narrow is-one-quarter is-family-monospace p-0 has-text-grey ${
                                              sms.patient ? "has-text-weight-semibold" : "has-text-weight-normal"
                                            }`}
                                          >
                                            {displayDateTime(sms.ts)}
                                          </div>
                                          <span
                                            key={idx}
                                            className={`sms-log column py-0 pr-0 pb-2 ${
                                              sms.patient ? "has-text-weight-semibold" : "has-text-weight-normal"
                                            }`}
                                          >
                                            {sms.text}
                                          </span>
                                        </div>
                                      )
                                    )}
                                  </div>
                                </div>
                                <div className="column is-narrow">
                                  <p className="menu-label">Notification Logs</p>
                                  <div className="sms-logs has-background-white">
                                    <NotificationLogList caId={activeCa.id} />
                                  </div>
                                </div>
                              </div>
                            )}
                            {workflowSelectedTabId === "sms" && (
                              <div>
                                <ManualSms
                                  isRTNoteFilled={_.get(
                                    _.find(archivedClientAppointments, (ca) => ca.id === activeCaId),
                                    "pre_consult_t.notes",
                                    false
                                  )}
                                  isSending={inAction}
                                  onSend={(template) => handleSendSMSMessage(template)}
                                />
                              </div>
                            )}
                            {workflowSelectedTabId === "email" && <EmailSection ca={ca} />}
                            {workflowSelectedTabId === "history" && (
                              <div className="history-table-wrapper">
                                <WorkflowHistoryList
                                  currentCa={ca}
                                  clinicPreference={clinicPreference}
                                  caDataLength={caData.length}
                                  handleClickManageTasks={handleClickManageTasks}
                                />
                              </div>
                            )}
                            {workflowSelectedTabId === "todos" && (
                              <TodoListTab
                                caId={activeCa.id}
                                clientFullName={`${_.get(activeCa, "client.firstName", "")} ${_.get(
                                  activeCa,
                                  "client.lastName",
                                  ""
                                )}`}
                              />
                            )}
                            {workflowSelectedTabId === "secure_files" && isSecureFilesEnabled && (
                              <SecureFileTab clientAppointmentId={activeCa.id} />
                            )}
                            {workflowSelectedTabId === "activity" && <ActivityTab ca={activeCa} />}
                            {workflowSelectedTabId === "gp_reports" && <GPReportListPanel ca={activeCa} />}
                            {!_.isNull(actionSuccess) && (
                              <article className={`${actionSuccess ? "is-success " : "is-danger "}message is-size-7`}>
                                <div className="message-body is-radiusless">
                                  {actionSuccess ? "action completed" : actionErrorMessage || "action failed"}
                                </div>
                              </article>
                            )}
                          </div>
                          <div className="panel-block is-justify-content-space-between">
                            <div className="field is-grouped is-pulled-left">
                              <p className="control">
                                <button
                                  className="button is-info is-outlined is-small is-radiusless"
                                  onClick={(e) => handleClickEditClient()}
                                >
                                  Edit Client
                                </button>
                              </p>
                              <p className="control">
                                <button
                                  className="button is-info is-outlined is-small is-radiusless"
                                  onClick={(e) => handleClickAddCancelAppointment()}
                                >
                                  {!_.has(
                                    _.find(archivedClientAppointments, (ca) => ca.id === activeCaId),
                                    "appointment.appointmentId"
                                  )
                                    ? "Add"
                                    : "Cancel"}{" "}
                                  Appointment
                                </button>
                              </p>
                              {_.has(
                                _.find(archivedClientAppointments, (ca) => ca.id === activeCaId),
                                "appointment.appointmentId"
                              ) && (
                                <p className="control">
                                  <button
                                    className="button is-info is-outlined is-small is-radiusless"
                                    onClick={(e) => handleClickChangeAppointment()}
                                  >
                                    Reschedule Appointment
                                  </button>
                                </p>
                              )}
                              <p className="control">
                                <button
                                  className={`button is-info is-outlined is-small is-radiusless ${
                                    isLoadingCa ? "is-loading" : ""
                                  }`}
                                  onClick={(e) => handleClickRebuild(activeCaId)}
                                >
                                  Rebuild
                                </button>
                              </p>
                              <p className="control">
                                <button
                                  className="button is-info is-outlined is-small is-radiusless"
                                  onClick={handleClickActingPatient}
                                >
                                  Acting Patient
                                </button>
                              </p>
                            </div>
                            <div className="field is-grouped is-pulled-right">
                              {isManualArchiveWorkflowEnabled &&
                                CLIENT_APPOINTMENTS.includes(
                                  _.find(archivedClientAppointments, (item) => item.id === activeCaId)?.appointment_t
                                    ?.status
                                ) && (
                                  <p className="control">
                                    <button
                                      className="button is-warning is-outlined is-small is-radiusless"
                                      onClick={handleClickUnarchive}
                                    >
                                      Unarchive Workflow
                                    </button>
                                  </p>
                                )}
                              <p className="control">
                                <button
                                  className="button is-danger is-outlined is-small is-radiusless"
                                  onClick={handleClickDelete}
                                >
                                  Delete Workflow
                                </button>
                              </p>
                            </div>
                          </div>
                          <div>{ca.id}</div>
                        </td>
                      </tr>
                    </>
                  )}
                </Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ArchivedWorkFlow);
